module.exports = " <div class=container-fluid> <navigation-admin></navigation-admin> <div class=\"row row-fluid\"> <sidebar-admin></sidebar-admin> <section class=\"col-sm-10 admin-background-shadow overflow\"> <div class=\"row row-fluid\"> <div class=col-sm-5> <admin-form></admin-form> </div> </div> </section> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin/Admin-users-form.vue
// module id = 574
// module chunks = 0